import 'angular';
import './resourceSelection.html';
import {IAuthenticatedUserService} from "../../types/ServiceTypes";
import {RootScope} from '../../types/angular-types';
import AppConstants from "../../gorillaboy/AppConstants";
import SignalProvider from "../../gorillaboy/SignalProvider";


function ResourceSelectionCtrlFn($rootScope: RootScope, $scope: ng.IScope, $log: ng.ILogService, FileManagerFactory, SystemTags, authenticatedUser: IAuthenticatedUserService, $translate: ng.translate.ITranslateService, MessageManager) {
    let userInfo = authenticatedUser.getUserInfo();
    FileManagerFactory.setUserContext(userInfo);
    $scope.fileManager = new FileManagerFactory.FileManager();
    $scope.$on("$destroy", function() {
        $scope.fileManager.destroy();
    });

    $scope.viewLoadingFlag = true;
    $scope.currentFolderId = null;
    $scope.loadMorePromise = null;

    $scope.selectedWrappedResource = null;
    $scope.okayButtonClicked = function() {
        let selectedResource = null;
        if ($scope.selectedWrappedResource.folder) {
            selectedResource = $scope.selectedWrappedResource.folder;
        } else if ($scope.selectedWrappedResource.document) {
            selectedResource = $scope.selectedWrappedResource.document;
        }
        $scope.$emit(SignalProvider.ResourceSelectionComponent.SelectionUpdated, selectedResource);
    };

    $scope.gotoFolder = function (Id: string, Name: string, resetPathListIndex: number) {
        if (typeof resetPathListIndex != "undefined") {
            $scope.pathList.length = resetPathListIndex + 1;
            $scope.pathList = $scope.pathList.concat([]);
        } else {
            $scope.pathList = $scope.pathList.concat([{
                Name: Name,
                Id : Id
            }]);
        }
        $scope.currentFolderId = Id;
        $scope.fileManager.setCurrentFolder(Id);
        reloadView();
    };

    const resetSelectionFn = (wrappedResource) => wrappedResource.isSelected = false;

    $scope.selectExclusively = function(wrappedResource) {
        if ($scope.selectedWrappedResource) {
            $scope.wrappedDocuments.forEach(resetSelectionFn);
            $scope.wrappedFolders.forEach(resetSelectionFn);
        }

        wrappedResource.isSelected = true;
        $scope.selectedWrappedResource = wrappedResource;
    };

    $scope.pathList = [{
        Name: "MyDocs",
        Id: null
    }];

    function loadMore() {
        if ($scope.loadMorePromise !== null || !$scope.fileManager.getMarker()) {
            return $scope.loadMorePromise;
        }

        $rootScope.$broadcast(SignalProvider.ContentLoading.Start);
        $scope.loadMorePromise = $scope.fileManager.loadMore().then(loadContentSucceededCallback, loadMoreFailureFn);
        $scope.loadMorePromise.finally(function() {
            $rootScope.$broadcast(SignalProvider.ContentLoading.Done);
            $scope.loadMorePromise = null;
        });
    }

    function loadMoreFailureFn(error) {
        $log.error('Failed to load more in resource selection modal. error: ' + JSON.stringify(error));
    }

    function reloadView() {
        $scope.viewLoadingFlag = true;
        if (!$scope.currentFolderId) {
            $scope.fileManager.setCurrentFolder(userInfo.RootFolderId);
        }
        $scope.fileManager.loadCurrentFolder()
            .then(loadContentSucceededCallback, loadContentFailedCallback);
    }

    function loadContentSucceededCallback() {
        $scope.wrappedDocuments = $scope.fileManager.getFiles().map(document => ({document, isSelected: false}));
        $scope.wrappedFolders = $scope.fileManager.getFolders().map(folder => ({folder, isSelected: false}));
        $scope.viewLoadingFlag = false;
        if ($scope.currentFolderId) {
            $scope.currentFolderName = $scope.fileManager.getCurrentFolderInfo().Metadata.Name;
        } else {
            $scope.currentFolderName = "MyDocs";
        }
    }

    function loadContentFailedCallback() {
        MessageManager.addErrorMessage($translate.instant('TASKS.TRANSFER_OWNERSHIP.MODAL.ERROR_MSGS.FETCHING_SHARED_WITH_ME_FAILED'));
        $scope.viewLoadingFlag = false;
    }

    reloadView();
    $scope.$on(SignalProvider.ContentLoading.LoadMore, function($event, data) {
        loadMore();
        $event.stopPropagation();
    });
}
ResourceSelectionCtrlFn.$inject = ['$rootScope', '$scope', '$log', 'FileManagerFactory', 'SystemTags', 'authenticatedUser', '$translate', 'MessageManager'];

angular.module('GorillaBoy.directives')
.controller('ResourceSelectionCtrl', ResourceSelectionCtrlFn)
.directive('resourceSelection', [() => {
    return {
        scope: true,
        controller : 'ResourceSelectionCtrl',
        templateUrl: './shared/resourceSelection/resourceSelection.html'
    };
}]);
